import { useState } from "react";
import Button from "../common/components/Button";
import Icon from "../common/components/Icon";
import { ReactNodeDialog } from "../common/utils/dialogUtlities";
import { Col, Row } from "../common/components/Grid";
import SiteDropdown from "./SiteDropdown";
import useClientConfig from "../common/hooks/clientConfigHook";
import LevelDropdown from "./LevelDropdown";
import TypeDropdown from "./TypeDropdown";
import { useSpecializedTranslation } from "../hooks/specializedTranslationHook";

const JobContinueButton = ({ disabled, onContinue }) => {
    const clientConfig = useClientConfig();
    const [ pendingAction, setPendingAction ] = useState(false);
    const { t } = useSpecializedTranslation(pendingAction);
    
    const handleChange = delta => {
        setPendingAction(pendingAction => ({ ...pendingAction, ...delta }));
    }

    const doContinue = () => {
        onContinue({ ...pendingAction });
        setPendingAction(false);
    }

    return <>
        <ReactNodeDialog title={t('continue')} showModal={pendingAction} onClose={() => setPendingAction(false)} onSave={doContinue}>
            { clientConfig ? <Row>
                <Col>
                    <SiteDropdown site={pendingAction.site} perm="any" onChange={handleChange}></SiteDropdown>
                </Col>
            </Row> : null }
            { clientConfig ? <Row>
                <Col>
                    <LevelDropdown site={pendingAction.level} level={pendingAction.level} perm="any" onChange={handleChange}></LevelDropdown>
                </Col>
            </Row> : null }
            <Row>
                <Col>
                    <TypeDropdown site={pendingAction.site} level={pendingAction.level} type={pendingAction.type} perm="any" onChange={v => handleChange({ site: v.site ?? pendingAction.site, level: v.level ?? pendingAction.level, type: v.type })}></TypeDropdown>
                </Col>
            </Row>
        </ReactNodeDialog>
        <Button variant="default" layout="stacked" disabled={disabled} onClick={() => setPendingAction({})}>
            <Icon variant="solid" kind="share"></Icon> {t('continue')}
        </Button>
    </>
}

export default JobContinueButton;